import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Form, CardTitle } from "reactstrap";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import configure from "configure";

const ViewProfile = ({ customer }) => {
  const [fixButtons, setFixButtons] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [Location, setLocation] = useState("");
  const [Country, setCountry] = useState("");
  const [State, setstate] = useState("");
  const [City, setcity] = useState("");

    const groups_option = [
    { label: "Regular", value: "1" },
    { label: "Monthly", value: "2" },
    { label: "Quarterly", value: "3" },
  ]

  useEffect(() => {
    fetchLocation();
    fetchCountry();
  }, []);

  const fetchLocation = async () => {
    setLoading(true);
    try {
      const responce = await axios({
        method: "get",
        url: `${configure.apiUrl}/all/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const location = res.data.locations.map((obj) => ({
          label: obj.location,
          value: obj.id,
        }));
        setLocation(
          location.filter((item) => item?.value == customer?.location)[0]?.label
        );
        setLoading(false);
      });
    } catch (error) {
      console.log("Add-lead-Country", error);
      setLoading(false);
    }
  };

  const fetchCountry = async () => {
    setLoading(true);
    try {
      const responce = await axios({
        method: "get",
        url: `${configure.apiUrl}/all/countries`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const location = res.data.countries.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setCountry(
          location.filter((item) => item?.value == customer?.country)[0]?.label
        );
        // fetchstate(customer?.country);
        setLoading(false);
      });
    } catch (error) {
      console.log("Add-lead-Country", error);
      setLoading(false);
    }
  };

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true);
    } else {
      setFixButtons(false);
    }
  });
  return (
    <React.Fragment>
      <div>
        <div>
          {/* Fixed Buttons */}
          <div
            className={`flex-column fixed-buttons ${fixButtons ? "d-flex" : "d-none"
              }`}
          >
            <a
              onClick={() => navigate(-1)}
              className="btn btn-red border-radius fix-btn"
            >
              <i className="dripicons-cross me-2 icon-center"></i>
              <span>Cancel</span>
            </a>
          </div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="px-4 py-0">
                  <CardTitle className="mb-1 mt-3 text-dark ps-2">
                    Profile
                  </CardTitle>

                  <Row className="px-1">
                    <Form>
                      <Row className="bg-white px-2 py-4 shadow mb-3 bd-span-input">
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">
                            Location <span className="text-danger">*</span>{" "}
                          </label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.country_name || "-"}
                          ></input>
                        </div>
                      </Row>
                      <Row className="bg-white px-2 py-4 mb-3 shadow bd-span-input">
                        <h5 className="mb-3">Company Information</h5>

                        <div className="col-md-4 mb-3">
                          <label htmlFor="">
                            Company <span className="text-danger">*</span>
                          </label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.company || "-"}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">GST/VAT Number</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.vatnumber != "null" ? customer?.vatnumber || "-" : ''}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label htmlFor="">
                            Source <span className="text-danger">*</span>{" "}
                          </label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.sourceDetails?.leadname || "-"}
                          />
                        </div>
                        {/* 
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">
                            {customer?.sourceDetails?.leadname}
                            <span className="text-danger">*</span>{" "}
                          </label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.customer_name || "-"}
                          />
                        </div> */}

                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Phone</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.phone || "-"}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Email Address</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.email != "null" ? customer?.email || "" : ''}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Website</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.website != 'null' ? customer?.website : ''}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Incorporation Date</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.corporationdate || "-"}
                          />
                        </div>
                      </Row>

                      <Row className="bg-white px-2 py-4  shadow bd-span-input">
                        <h5 className="mb-3">Address</h5>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Country</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.country_name	 || "-"}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">State</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.state_name	 || "-"}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">City </label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.city_name	 || "-"}
                          />
                        </div>

                        <div className="col-md-8 mb-3 ">
                          <label htmlFor="">Address</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.address || "-"}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Zip Code</label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.zipcode || "-"}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Groups </label>
                          <input
                            disabled
                            className="form-control"
                            value={groups_option?.find((obj) => obj?.value == customer?.groups)?.label || "-"}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label htmlFor="">Currency </label>
                          <input
                            disabled
                            className="form-control"
                            value={customer?.currencyDetails?.currency || "-"}
                          />
                        </div>
                      </Row>
                    </Form>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewProfile;
